module.exports = __webpack_public_path__ + "assets/img/zhou.9d6f0ee4.png";